module.exports = __webpack_public_path__ + "static/media/Finding-profitable-offers-online-552598-min.95d42347.jpg";